import {
  Component,
  ComponentInterface,
  Element,
  Event,
  EventEmitter,
  h,
  Host,
  Prop,
  Watch,
} from '@stencil/core';
import { Modal } from 'bootstrap';
import { BsWebcomponent } from '../../bahf-header/bsWebcomponent';
import { CookieDisclaimerController } from '../controller/CookieDisclaimerController';

/**
 * @internal
 */
@Component({
  tag: 'bahf-cd-modal',
  styleUrl: 'bahf-cd-modal.scss',
  shadow: false,
  scoped: true,
})
export class BahfCdModal implements ComponentInterface {
  @Prop() modalId = 'bahf-cookie-disclaimer-modal';

  @Prop() isOpen = false;

  @Prop() controller: CookieDisclaimerController;

  @Element() modalElem: HTMLElement;

  ownModal: Modal;

  /**
   * Dieses Event wird ausgelöst, wenn der Cookie-Disclaimer-Modal geöffnet wird.
   */
  @Event({ eventName: 'bahfCdOpened' }) bahfCdOpen: EventEmitter;
  /**
   * Dieses Event wird ausgelöst, wenn der Cookie-Disclaimer-Modal geschlossen wird.
   */
  @Event({ eventName: 'bahfCdClosed' }) bahfCdClose: EventEmitter;

  @Watch('isOpen')
  watchIsOpenHandler(newVal: boolean) {
    try {
      if (newVal) {
        this.ownModal.show();
        this.bahfCdOpen.emit();
      } else {
        this.ownModal.hide();
        this.bahfCdClose.emit();
      }
    } catch (err) {}
  }

  private readonly LAST_FOCUSABLE_ELEMENT_INDEX = 2;

  private readonly FIRST_FOCUSABLE_ELEMENT_INDEX = 1;

  private setFocusTrap(targetId: string, focusableElements: NodeListOf<HTMLElement>) {
    if (targetId === 'bahf-cd-first-elem') {
      (
        focusableElements[
          focusableElements.length - this.LAST_FOCUSABLE_ELEMENT_INDEX
        ]
      ).focus();
    } else if (targetId === 'bahf-cd-last-elem') {
      (focusableElements[this.FIRST_FOCUSABLE_ELEMENT_INDEX]).focus();
    }
  }

  componentDidLoad() {
    const _m = new BsWebcomponent(this.modalElem);
    if (window.dpl?.bs) {
      this.ownModal = new window.dpl.bs.Modal(this.modalElem.querySelector(`#${this.modalId}`), {
        backdrop: 'static',
        keyboard: false,
        focus: false,
      });
    }
    const focusableElements: NodeListOf<HTMLElement> = this.modalElem.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    this.modalElem.querySelector('#bahf-cd-last-elem').addEventListener('focus', () => {
      this.setFocusTrap('bahf-cd-last-elem', focusableElements);
    });

    this.modalElem.querySelector('#bahf-cd-first-elem').addEventListener('focus', () => {
      this.setFocusTrap('bahf-cd-first-elem', focusableElements);
    });

    this.modalElem.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.controller.handleClose();
      }
    });

    this.watchIsOpenHandler(this.isOpen);
  }

  render() {
    return (
      <Host>
        <div tabindex={this.isOpen ? '0' : '-1'} id="bahf-cd-first-elem" />
        <div
          class="modal ba-keyboard-mode fade"
          id={this.modalId}
          role="dialog"
          tabindex="-1"
          aria-label="Cookie-Einstellungen"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content sticky-modal-footer">
              <slot />
            </div>
          </div>
        </div>
        <div tabindex={this.isOpen ? '0' : '-1'} id="bahf-cd-last-elem" />
      </Host>
    );
  }
}
